module.exports = __webpack_public_path__ + "9788f41e/img/note-list-icon.961c1485.svg";